import {
	CLAIM_PROJECT_FORM_MODULE_ID, REJECT_PROJECT_MODAL_MODULE_ID,
} from 'root/src/shared/descriptions/modules/moduleIds'
import claimProject from 'root/src/client/logic/project/thunks/claimProject'
import deliveryDare from 'root/src/client/logic/project/thunks/deliveryDare'
import deliveryDareOnSuccess from 'root/src/client/logic/project/thunks/deliveryDareOnSuccess'
import { claimProjectFormStepKeys } from 'root/src/shared/descriptions/modules/claimProjectForm'
import displayModal from 'root/src/client/logic/modal/actions/displayModal'

export default {
	[CLAIM_PROJECT_FORM_MODULE_ID]: [
		{
			action: claimProject,
			stepId: claimProjectFormStepKeys.root,
		},
		{
			action: deliveryDare,
			stepId: claimProjectFormStepKeys.deliver,
			onSuccess: deliveryDareOnSuccess,
		},
		{
			action: () => dispatch => dispatch(displayModal(REJECT_PROJECT_MODAL_MODULE_ID)),
			stepId: claimProjectFormStepKeys.deliver,
		},
	],
}
